/**
 * Debounce delay for user-triggered UI actions that should execute immediately
 * and ignore rapid repeat clicks.
 */
export const UI_ACTION_DEBOUNCE_MS = 300;

/** Shared maximum length for user-editable display names. */
export const DISPLAY_NAME_MAX_LENGTH = 100;
